import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.finally.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseScheme } from '@nuxtjs/auth-next/dist/runtime';
import Token from '~/plugins/token';
import meQuery from '~/graphql/queries/user/me.gql';
import loginMutation from '~/graphql/mutations/auth/login.gql';
import logoutMutation from '~/graphql/mutations/auth/logout.gql';
var DEFAULTS = {
  name: 'apollo',
  token: {
    property: 'token',
    type: 'Bearer',
    name: 'Authorization',
    maxAge: 1800,
    global: true,
    required: true,
    prefix: '_token.',
    expirationPrefix: '_token_expiration.'
  },
  user: {
    property: 'user',
    autoFetch: true
  }
};

var ApolloScheme = /*#__PURE__*/function (_BaseScheme) {
  _inherits(ApolloScheme, _BaseScheme);

  var _super = _createSuper(ApolloScheme);

  function ApolloScheme(auth, options) {
    var _this;

    _classCallCheck(this, ApolloScheme);

    var opts = _objectSpread(_objectSpread({}, DEFAULTS), options);

    _this = _super.call(this, auth, opts);
    _this.$auth = auth;
    _this.$apollo = auth.ctx.app.apolloProvider.defaultClient;
    _this.token = new Token(_assertThisInitialized(_this), _this.$auth.$storage);
    _this._name = options.name;
    _this._apolloCache = auth.ctx.app.apolloProvider.defaultClient.cache;
    return _this;
  }

  _createClass(ApolloScheme, [{
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var data, _yield$this$$apollo$m, login;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _ref.data;
                _context.next = 3;
                return this.$apollo.mutate({
                  mutation: loginMutation,
                  variables: data
                });

              case 3:
                _yield$this$$apollo$m = _context.sent;
                login = _yield$this$$apollo$m.data.login;
                _context.next = 7;
                return this.$auth.setUserToken(login);

              case 7:
                _context.next = 9;
                return this.fetchUser();

              case 9:
                _context.next = 11;
                return this.$apollo.cache.reset();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function login(_x) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "fetchUser",
    value: function fetchUser() {
      var _this2 = this;

      if (!this.$auth.check().valid) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject(false);
      }

      return this.$apollo.query({
        query: meQuery,
        fetchPolicy: 'no-cache'
      }).then(function (_ref2) {
        var me = _ref2.data.me;
        return me;
      }).then(function (data) {
        return _this2.$auth.setUser(data);
      });
    }
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.reset();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$apollo.mutate({
                  mutation: logoutMutation
                });

              case 2:
                _context3.next = 4;
                return this._apolloCache.reset();

              case 4:
                _context3.next = 6;
                return this.$auth.setUserToken(null, null);

              case 6:
                return _context3.abrupt("return", this.$auth.setUser(null));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "check",
    value: function check() {
      var cookieName = "".concat(this.$auth.options.cookie.prefix, "_token.").concat(this._name);
      var cookies = this.$auth.$storage.getCookies();
      return {
        valid: Boolean(cookies[cookieName])
      };
    }
  }]);

  return ApolloScheme;
}(BaseScheme);

export { ApolloScheme as default };